import { ActionTree, GetterTree, Module } from 'vuex'
import _union from 'lodash/union'

import { RootState } from '@/@next/store'

import { Language, LanguageCode } from '@/@next/@types'

import * as LANGUAGE from './types'
import { mutations } from './mutations'
import removeArrayDuplicate from '@/@next/helpers/removeArrayDuplicate'
import formatedISO from '@/@next/helpers/formatedISO'

export class LanguagesState {
  all: Language[] = []
  current: LanguageCode = ''
  default: LanguageCode = 'fr'
  userLanguages: LanguageCode[] = ['fr']
  target: string | null = null
  translatableTargets: any[] = []
}

const state: LanguagesState = new LanguagesState()

const getters: GetterTree<LanguagesState, RootState> = {
  [LANGUAGE.GET_ALL]: (state) => state.all,
  [LANGUAGE.GET_ALL_ISO]: (state) => {
    const isos = state.all.map((language) => language.iso)
    isos.unshift(state.current)
    return _union(isos)
  },
  [LANGUAGE.GET_CURRENT]: (state) => state.current,
  [LANGUAGE.GET_USER_LANGUAGES]: (state) => state.userLanguages,
  [LANGUAGE.GET_DEFAULT]: (state) => state.default,
  [LANGUAGE.GET_TARGET]: (state) => state.target,
  [LANGUAGE.GET_TRANSLATABLE_TARGETS]: (state) => state.translatableTargets,
  [LANGUAGE.GET_AVAILABLE_TARGETS]: (state) => {
    state.translatableTargets.filter((t: any) => t.languages.includes(state.current)).map((t: any) => t.target)
  }
}

export const actions: ActionTree<LanguagesState, RootState> = {
  [LANGUAGE.SET_ALL] ({ commit, dispatch }, languages: Language[]) {
    // Save available application languages
    commit(LANGUAGE.SET_ALL, languages)
    // Update user languages preferences for displaying i18n contents
    dispatch(LANGUAGE.SET_USER_LANGUAGES)
  },
  [LANGUAGE.SET_CURRENT] ({ commit, dispatch }, iso: string) {
    // Save current user language
    commit(LANGUAGE.SET_CURRENT, iso)
    // Update user languages preferences for displaying i18n contents
    dispatch(LANGUAGE.SET_USER_LANGUAGES)
  },
  [LANGUAGE.SET_USER_LANGUAGES] ({ state, commit }) {
    // Get Current User Navigator Languages
    const navigatorLanguages = removeArrayDuplicate(navigator.languages.map((iso) => formatedISO(iso)))
    // Filter Navigator Languages with app languages
    const userLanguages = navigatorLanguages.filter((l) => state.all.map(({ iso }) => iso).includes(l))
    // Add current language at first user preferences
    if (state.current.length > 0) userLanguages.unshift(state.current)
    // Add default language at last choice
    userLanguages.push(state.default)
     // Save user languages preferences for displaying i18n contents
    commit(LANGUAGE.SET_USER_LANGUAGES, removeArrayDuplicate(userLanguages))
  },
}

export const languages: Module<LanguagesState, RootState> = {
  state,
  getters,
  mutations,
  actions
}
